"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8689,9112],{

/***/ 34215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ColorfulTitleComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12573);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var COLOR_END_TAG = "</end>";
var ColorfulTitleComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ColorfulTitleComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ColorfulTitleComponent);
    function ColorfulTitleComponent(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, ColorfulTitleComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "renderTitle", function() {
            var _props = _this.props, text = _props.text, fontSize = _props.fontSize, isH1Heading = _props.isH1Heading;
            var title = _this.convertToHtml(text, fontSize);
            var className = "colorful-title";
            var style = {
                fontSize: fontSize
            };
            if (isH1Heading) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: className,
                    dangerouslySetInnerHTML: {
                        __html: title
                    },
                    style: style
                });
            } else {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: className,
                    dangerouslySetInnerHTML: {
                        __html: title
                    },
                    style: style
                });
            }
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ColorfulTitleComponent, [
        {
            key: "convertToHtml",
            value: function convertToHtml(text, fontSize) {
                text = text || "";
                // converting to spans with colors
                var html = "";
                // searching for first '<'
                var index = text.indexOf("<brand");
                if (index === -1) {
                    return text;
                }
                // regular text
                html = text.substring(0, index);
                // getting color
                var colorEndIndex = text.indexOf(">", index);
                var color = text.substring(index + 1, colorEndIndex);
                var endOfColoredText = text.indexOf(COLOR_END_TAG);
                if (endOfColoredText === -1) {
                    endOfColoredText = text.length;
                }
                var colorText = text.substring(colorEndIndex + 1, endOfColoredText);
                html += '<span class="colored" style="color: '.concat(_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[color], "; font-size: ").concat(fontSize, '">').concat(colorText, "</span>");
                var restOfText = text.substring(endOfColoredText + COLOR_END_TAG.length);
                return html + this.convertToHtml(restOfText);
            }
        },
        {
            key: "render",
            value: function render() {
                var className = this.props.className;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("title-container", className),
                    children: this.renderTitle()
                });
            }
        }
    ]);
    return ColorfulTitleComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
// This component gets a single text in the form of
// "This is an <brand-blue>Example</end> for a <brand-pink>colorful title</end>."

ColorfulTitleComponent.defaultProps = {
    isH1Heading: false
};


/***/ }),

/***/ 66370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImagesGalleryComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _images_gallery_row_images_gallery_row_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99112);







var ImagesGalleryComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ImagesGalleryComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ImagesGalleryComponent);
    function ImagesGalleryComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ImagesGalleryComponent);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ImagesGalleryComponent, [
        {
            key: "convertToMatrixIfNeeded",
            value: function convertToMatrixIfNeeded(assets) {
                if (assets && !Array.isArray(assets[0])) {
                    return [
                        assets
                    ];
                }
                return assets;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, assets = _props.assets, shadow = _props.shadow, screenRatios = _props.screenRatios, grayscale = _props.grayscale, shouldTrackMouseEvents = _props.shouldTrackMouseEvents;
                assets = this.convertToMatrixIfNeeded(assets);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "images-gallery",
                    children: assets.map(function(assetsRow, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_gallery_row_images_gallery_row_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            grayscale: grayscale,
                            assets: assetsRow,
                            shadow: shadow,
                            screenRatios: screenRatios,
                            shouldTrackMouseEvents: shouldTrackMouseEvents
                        }, index);
                    })
                });
            }
        }
    ]);
    return ImagesGalleryComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

ImagesGalleryComponent.defaultProps = {
    assets: [],
    grayscale: false
};


/***/ }),

/***/ 99112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ImagesGalleryRowComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/images-gallery/images-gallery-row/images-gallery-row-component.scss.js

var StyledImagesGalleryRowComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10syk230"
})("display:flex;justify-content:center;flex-wrap:wrap;");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./components/core/paragraph/paragraph-component.js + 1 modules
var paragraph_component = __webpack_require__(94950);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/images-gallery/images-gallery-row/image-gallery/image-gallery-component.scss.js


var StyledImageGalleryComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ekgspoc0"
})("display:flex;justify-content:center;align-items:center;flex-direction:column;position:relative;&.shadow{box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);}&.clickable{cursor:pointer;&:not(:hover){transition:0.2s all ease;}&:hover{transform:scale(1.05);}}a{text-decoration:none;color:", colors/* default.black */.Z.black, ";}.image-text{padding:16px 0;text-align:center;}");

;// CONCATENATED MODULE: ./components/core/images-gallery/images-gallery-row/image-gallery/image-gallery-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}






var ImageGalleryComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ImageGalleryComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ImageGalleryComponent);
    function ImageGalleryComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ImageGalleryComponent);
        var _this;
        _this = _super.call(this, props);
        _this.moveToPage = _this.moveToPage.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ImageGalleryComponent, [
        {
            key: "moveToPage",
            value: function moveToPage() {
                var href = this.props.href;
                window.location.href = href;
            }
        },
        {
            key: "getSpecificImageStyle",
            value: function getSpecificImageStyle() {
                var grayscale = this.props.grayscale;
                var style = grayscale == "true" ? {
                    filter: "grayscale(100%)"
                } : {};
                return style;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, url = _props.url, alt = _props.alt, paragraph = _props.paragraph, shadow = _props.shadow, href = _props.href, screenRatios = _props.screenRatios, shouldTrackMouseEvents = _props.shouldTrackMouseEvents;
                var specifyStyle = this.getSpecificImageStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledImageGalleryComponent, {
                    className: classnames_default()("image-gallery", {
                        shadow: shadow,
                        clickable: href
                    }),
                    onClick: href ? this.moveToPage : undefined,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            specificImageStyle: specifyStyle,
                            src: url,
                            alt: alt,
                            pictureClass: "social-proof-gallery-picture",
                            screenRatios: screenRatios,
                            shouldTrackMouseEvents: shouldTrackMouseEvents
                        }),
                        paragraph && /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, _object_spread({}, paragraph))
                    ]
                });
            }
        }
    ]);
    return ImageGalleryComponent;
}(react.PureComponent);

ImageGalleryComponent.defaultProps = {
    url: "",
    alt: "",
    grayscale: false
};

;// CONCATENATED MODULE: ./components/core/images-gallery/images-gallery-row/images-gallery-row-component.js




function images_gallery_row_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function images_gallery_row_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            images_gallery_row_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var ImagesGalleryRowComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ImagesGalleryRowComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ImagesGalleryRowComponent);
    function ImagesGalleryRowComponent() {
        (0,_class_call_check/* default */.Z)(this, ImagesGalleryRowComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ImagesGalleryRowComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, assets = _props.assets, shadow = _props.shadow, screenRatios = _props.screenRatios, grayscale = _props.grayscale, shouldTrackMouseEvents = _props.shouldTrackMouseEvents;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImagesGalleryRowComponent, {
                    className: "images-gallery-row",
                    children: assets.map(function(asset) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGalleryComponent, _object_spread_props(images_gallery_row_component_object_spread({}, asset), {
                            alt: asset.name,
                            shadow: shadow,
                            grayscale: grayscale,
                            screenRatios: screenRatios,
                            shouldTrackMouseEvents: shouldTrackMouseEvents
                        }), "".concat(asset.url, "_").concat(asset.name));
                    })
                });
            }
        }
    ]);
    return ImagesGalleryRowComponent;
}(react.PureComponent);



/***/ }),

/***/ 94703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LottieComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lottie-web/build/player/lottie.js
var lottie = __webpack_require__(11248);
var lottie_default = /*#__PURE__*/__webpack_require__.n(lottie);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/lottie/lottie-component.scss.js


var StyledLottieComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erlhttt0"
})("width:100%;height:100%;@media (min-width:", vp_sizes/* FOLD_TEST_MAX_WIDTH */.LM, "){&.above-the-fold{width:50%;transform:scale(-1);}}");

;// CONCATENATED MODULE: ./components/core/lottie/lottie-component.js











var LottieComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LottieComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LottieComponent);
    function LottieComponent(props) {
        (0,_class_call_check/* default */.Z)(this, LottieComponent);
        var _this;
        _this = _super.call(this, props);
        _this.fireActionIfReachedFrame = _this.fireActionIfReachedFrame.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(LottieComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, jsonPath = _props.jsonPath, loop = _props.loop, autoplay = _props.autoplay, fireActionOnFrame = _props.fireActionOnFrame;
                this.animtaion = lottie_default().loadAnimation({
                    container: this._lottieDiv,
                    renderer: "svg",
                    loop: loop,
                    autoplay: autoplay,
                    path: (0,cloudinary_service.generateCloudinaryRawUrl)(jsonPath)
                });
                var frame = fireActionOnFrame.frame, action = fireActionOnFrame.action;
                if (frame && action) {
                    this.animtaion.onEnterFrame = this.fireActionIfReachedFrame;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.animtaion.onEnterFrame = null;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _props = this.props, shouldPlay = _props.shouldPlay, reverseAnimation = _props.reverseAnimation, shouldPause = _props.shouldPause;
                var animationDirection = reverseAnimation ? -1 : 1;
                this.animtaion.setDirection(animationDirection);
                shouldPlay && this.animtaion.play();
                shouldPause && this.animtaion.pause();
            }
        },
        {
            key: "fireActionIfReachedFrame",
            value: function fireActionIfReachedFrame(param) {
                var currentTime = param.currentTime;
                var _props = this.props, reverseAnimation = _props.reverseAnimation, fireActionOnFrame = _props.fireActionOnFrame;
                var frame = fireActionOnFrame.frame, action = fireActionOnFrame.action;
                if (currentTime > frame && !reverseAnimation) {
                    action();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var aboveTheFold = this.props.aboveTheFold;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLottieComponent, {
                    ref: function(lottieDiv) {
                        return _this._lottieDiv = lottieDiv;
                    },
                    className: classnames_default()("lottie-component", {
                        "above-the-fold": aboveTheFold
                    })
                });
            }
        }
    ]);
    return LottieComponent;
}(react.PureComponent);

LottieComponent.defaultProps = {
    jsonPath: "/static/lottie/arrow-swirl-down.json",
    autoplay: false,
    loop: false,
    fireActionOnFrame: {}
};


/***/ }),

/***/ 71025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CollaborationWithComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/one-pager/collaboration-with/collaboration-with-component.scss.js


var _defaultExport = new String(".collaboration-with-component.jsx-cab28dc4592febf5{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:-webkit-calc(.875rem + .6vw);font-size:-moz-calc(.875rem + .6vw);font-size:calc(.875rem + .6vw);-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-top:24px;.collaboration-with-text.jsx-cab28dc4592febf5{font-weight:400}.collaboration-with-image-wrapper.jsx-cab28dc4592febf5{margin-left:16px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;.collaboration-with-image.jsx-cab28dc4592febf5{max-height:2vw;min-height:32px}}}@media(max-width:".concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.collaboration-with-component.jsx-cab28dc4592febf5{font-size:-webkit-calc(.875rem + 1vw);font-size:-moz-calc(.875rem + 1vw);font-size:calc(.875rem + 1vw);.collaboration-with-image-wrapper.jsx-cab28dc4592febf5{.collaboration-with-image.jsx-cab28dc4592febf5{max-height:4vw;min-height:2vw}}}}"));
_defaultExport.__hash = "cab28dc4592febf5";
/* harmony default export */ var collaboration_with_component_scss = (_defaultExport);

// EXTERNAL MODULE: ./services/community/url-service.js
var url_service = __webpack_require__(932);
;// CONCATENATED MODULE: ./components/core/one-pager/collaboration-with/collaboration-with-component.js










var CollaborationWithComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CollaborationWithComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CollaborationWithComponent);
    function CollaborationWithComponent() {
        (0,_class_call_check/* default */.Z)(this, CollaborationWithComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CollaborationWithComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, imageUrl = _props.imageUrl, color = _props.color, text = _props.text;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        color: colors/* default */.Z[color]
                    },
                    className: "jsx-".concat(collaboration_with_component_scss.__hash) + " " + "collaboration-with-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(collaboration_with_component_scss.__hash) + " " + "collaboration-with-text",
                            children: text
                        }),
                        imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(collaboration_with_component_scss.__hash) + " " + "collaboration-with-image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,url_service.fixDevImageUrl)(imageUrl),
                                className: "jsx-".concat(collaboration_with_component_scss.__hash) + " " + "collaboration-with-image"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: collaboration_with_component_scss.__hash,
                            children: collaboration_with_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return CollaborationWithComponent;
}(react.PureComponent);

CollaborationWithComponent.defaultProps = {
    color: "black",
    text: "Powered By"
};


/***/ }),

/***/ 63126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextPartComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
;// CONCATENATED MODULE: ./static/svg/icons/checkmark2.svg
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgCheckmark2 = function SvgCheckmark2(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 23 23"
    }, props), /*#__PURE__*/ react.createElement("path", {
        d: "m15.88 8.44-6.57 6.12-2.18-2.18",
        style: {
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }
    }), /*#__PURE__*/ react.createElement("circle", {
        cx: 11.5,
        cy: 11.5,
        r: 10.06,
        style: {
            fill: "none",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }
    }));
};
/* harmony default export */ var checkmark2 = (SvgCheckmark2);

// EXTERNAL MODULE: ./components/core/one-pager/collaboration-with/collaboration-with-component.js + 1 modules
var collaboration_with_component = __webpack_require__(71025);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
;// CONCATENATED MODULE: ./components/core/one-pager/youtube-cta/youtube-cta-component.scss.js
var _defaultExport = new String(".button-content{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;color:white;.play-icon{padding-right:8px;svg{width:18px;height:18px}}.play-text{font-size:1rem}}");
_defaultExport.__hash = "595d037c7d9fec5c";
/* harmony default export */ var youtube_cta_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./static/svg/play_icon_white.svg
var _g;
function play_icon_white_extends() {
    play_icon_white_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return play_icon_white_extends.apply(this, arguments);
}

var SvgPlayIconWhite = function SvgPlayIconWhite(props) {
    return /*#__PURE__*/ react.createElement("svg", play_icon_white_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        viewBox: "0 0 18 18"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(1 1)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "m11.386 7.722-4.19-2.89c-.341-.235-.863-.007-.863.574v5.778c0 .521.485.835.862.574l4.19-2.889c.375-.257.376-.89 0-1.147"
    }), /*#__PURE__*/ react.createElement("circle", {
        cx: 8,
        cy: 8,
        r: 8,
        stroke: "#FFF"
    }))));
};
/* harmony default export */ var play_icon_white = (SvgPlayIconWhite);

// EXTERNAL MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.js + 7 modules
var youtube_video_modal_component = __webpack_require__(60202);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
;// CONCATENATED MODULE: ./components/core/one-pager/youtube-cta/youtube-cta-component.js













var BIGBRAIN_SECOND_CTA_KIND = "second-cta";
var YoutubeCtaComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(YoutubeCtaComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(YoutubeCtaComponent);
    function YoutubeCtaComponent(props) {
        (0,_class_call_check/* default */.Z)(this, YoutubeCtaComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            openModal: false
        };
        _this.onPlayButtonClicked = _this.onPlayButtonClicked.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.closeModal = _this.closeModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderButtonContent = _this.renderButtonContent.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(YoutubeCtaComponent, [
        {
            key: "onPlayButtonClicked",
            value: function onPlayButtonClicked() {
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_OPEN, {
                    kind: BIGBRAIN_SECOND_CTA_KIND
                });
                this.setState({
                    openModal: true
                });
            }
        },
        {
            key: "closeModal",
            value: function closeModal() {
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_CLOSE, {
                    kind: BIGBRAIN_SECOND_CTA_KIND
                });
                this.setState({
                    openModal: false
                });
            }
        },
        {
            key: "renderButtonContent",
            value: function renderButtonContent() {
                var playButtonText = this.props.playButtonText;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "button-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "play-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(play_icon_white, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "play-text",
                            children: [
                                " ",
                                playButtonText
                            ]
                        })
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, videoId = _props.videoId, footerText = _props.footerText, width = _props.width, height = _props.height, autoplay = _props.autoplay, buttonColor = _props.buttonColor, buttonSize = _props.buttonSize;
                var openModal = this.state.openModal;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(youtube_cta_component_scss.__hash) + " " + "youtube-cta-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                            className: "watch-video-button",
                            color: buttonColor,
                            size: buttonSize,
                            onClickCallback: this.onPlayButtonClicked,
                            children: this.renderButtonContent()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_modal_component/* default */.Z, {
                            footerText: footerText,
                            videoId: videoId,
                            isOpen: openModal,
                            opts: {
                                width: width,
                                height: height,
                                playerVars: {
                                    autoplay: autoplay,
                                    rel: 0,
                                    showinfo: 0
                                }
                            },
                            onCloseModal: this.closeModal
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: youtube_cta_component_scss.__hash,
                            children: youtube_cta_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return YoutubeCtaComponent;
}(react.PureComponent);

YoutubeCtaComponent.defaultProps = {
    width: 970,
    height: 546,
    autoplay: 1,
    buttonColor: "brand-blue",
    buttonSize: "md"
};

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/one-pager/desktop-content/text-part/text-part-component.scss.js


var text_part_component_scss_defaultExport = new String(".text-part-component{.title-lines-wrapper{margin-bottom:24px;b {\n        font-weight: 700 !important;\n      }\n    .title-line{font-size:2.531rem;margin-bottom:8px;font-weight:300;display:block}}.subtitle-lines-wrapper{.subtitle-line{font-size:1.238rem;margin-bottom:16px;display:block}}.text-part-signup-form-wrapper{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin:32px 0}.text-part-bullets{.bullet-line{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin-bottom:16px;.bullet-line-icon-wrapper{-webkit-box-flex:0;-webkit-flex:0 0 24px;-moz-box-flex:0;-ms-flex:0 0 24px;flex:0 0 24px;margin-right:8px;svg{vertical-align:middle}&.white{svg{path,\n              circle {\n                stroke: white;\n              }\n            }}}.bullet-line-content{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;font-size:1rem}}}.second-cta-wrapper{padding-top:24px}}@media(max-width:".concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.text-part-component{.title-lines-wrapper{.title-line{font-size:1.913rem}}.subtitle-lines-wrapper{.subtitle-line{font-size:1.125rem;line-height:32px}}.text-part-signup-form-wrapper{display:block}.text-part-bullets{display:none}}}"));
text_part_component_scss_defaultExport.__hash = "fad960dc50a572d5";
/* harmony default export */ var text_part_component_scss = (text_part_component_scss_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/desktop-content/text-part/text-part-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var TextPartComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TextPartComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TextPartComponent);
    function TextPartComponent() {
        (0,_class_call_check/* default */.Z)(this, TextPartComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TextPartComponent, [
        {
            key: "getTitleLineStyle",
            value: function getTitleLineStyle() {
                var _props = this.props, titleLinesFontSize = _props.titleLinesFontSize, color = _props.color;
                return {
                    color: colors/* default */.Z[color],
                    fontSize: titleLinesFontSize
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, titleLines = _props.titleLines, subtitleLines = _props.subtitleLines, bullets = _props.bullets, color = _props.color, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith, popupVideo = _props.popupVideo;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + "text-part-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "title-lines-wrapper",
                            children: titleLines.map(function(line, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: line
                                    },
                                    style: _this.getTitleLineStyle(),
                                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + "title-line"
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "subtitle-lines-wrapper",
                            children: subtitleLines.map(function(line, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: line
                                    },
                                    style: {
                                        color: colors/* default */.Z[color]
                                    },
                                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + "subtitle-line"
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "text-part-signup-form-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                placeholder: signupForm.inputPlaceholder,
                                ctaText: signupForm.buttonText,
                                useCtaText: !!signupForm.buttonText,
                                buttonColor: signupForm.buttonColor,
                                focusOnLoad: signupForm.focusOnLoad,
                                className: "align-left"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "text-part-bullets",
                            children: bullets.map(function(line, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + "bullet-line",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "bullet-line-icon-wrapper ".concat(color),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkmark2, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: line
                                            },
                                            style: {
                                                color: colors/* default */.Z[color]
                                            },
                                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "bullet-line-content"
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        collaborationWith.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(collaboration_with_component/* default */.Z, _object_spread({}, collaborationWith)),
                        popupVideo.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "second-cta-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeCtaComponent, _object_spread({}, popupVideo))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: text_part_component_scss.__hash,
                            children: text_part_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return TextPartComponent;
}(react.PureComponent);

TextPartComponent.defaultProps = {
    titleLines: [
        "Project Management",
        "<b>is better when it's visual"
    ],
    subtitleLines: [
        "See what everyone on your team is working on in a single glance"
    ],
    bullets: [
        "Manage your projects & tasks with ease",
        "Plan visually on a timeline",
        "Centralize communication in one place"
    ],
    popupVideo: {}
};


/***/ }),

/***/ 57858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextPartComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
;// CONCATENATED MODULE: ./services/onelink-service.js



var ONELINK_BASE_URL = "https://go.onelink.me/wwJQ";
var getOnelinkWithTrackingParams = function() {
    var url = window.location;
    var finalUrl = ONELINK_BASE_URL;
    // Parse URI, get query string hash
    var queryString = (0,utils_url.getQueryStringAsHash)(url);
    var m_source = queryString.marketing_source || queryString.utm_source;
    var m_banner = queryString.marketing_banner || queryString.utm_banner;
    var visitorId = (0,cookies_service/* getCookie */.ej)(constants_cookies.BIG_BRAIN_VISITOR_ID);
    // Indicate that the origin is mobile web.
    finalUrl += "?is_mobile_web=true";
    // Add source if given.
    if (m_source) {
        finalUrl += "&pid=".concat(m_source);
    }
    // Add banner if given.
    if (m_banner) {
        finalUrl += "&c=".concat(m_banner);
    }
    if (visitorId) {
        finalUrl += "&visitor_id=".concat(visitorId);
    }
    return finalUrl;
};

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/core/one-pager/collaboration-with/collaboration-with-component.js + 1 modules
var collaboration_with_component = __webpack_require__(71025);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
;// CONCATENATED MODULE: ./services/platform-api-service.js
function platform_api_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            platform_api_service_define_property(target, key, source[key]);
        });
    }
    return target;
}
var URL_BASE = "https://auth.monday.com";
var DEFAULT_FETCH_OPTIONS = {
    credentials: "same-origin",
    headers: {
        "Content-Type": "application/json"
    }
};
var baseFetch = function(url, options) {
    return fetch(url, _object_spread({}, DEFAULT_FETCH_OPTIONS, options));
};
var sendCookies = function(visitorId, cookies) {
    return baseFetch("".concat(URL_BASE, "/set_visitor_cookies"), {
        method: "POST",
        body: JSON.stringify({
            visitor_id: visitorId,
            cookies: cookies
        })
    });
};

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.scss.js


var _defaultExport = new String(".text-part-component.jsx-5ddbce48fc0d5d15{margin:16px 0;padding:0px 8px;text-align:center;.title-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:16px;.title-line.jsx-5ddbce48fc0d5d15{font-size:1.575rem;line-height:32px;display:block}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:54px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:1.125rem;line-height:8px;display:block}}.mobile-download-button-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:20px;.mobile-download-button{width:100%}}&.big-text.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{font-size:6vw;line-height:7vw}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:3vw;line-height:2vw}}}&.mobile-only.jsx-5ddbce48fc0d5d15{&.big-text.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{font-size:8vw;line-height:10vw}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:24px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:5vw;line-height:3vw}}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{.subtitle-line.jsx-5ddbce48fc0d5d15{margin-bottom:16px}}&.mobile-clean-look.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{display:block;font-size:8vw;line-height:9vw;font-weight:500;padding-left:10%;padding-right:10%;margin-bottom:0;&.first.jsx-5ddbce48fc0d5d15{line-height:10vw}}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:24px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:5vw;line-height:3vw}}.mobile-download-button-wrapper.jsx-5ddbce48fc0d5d15{.mobile-download-button{width:70%;min-width:220px;background-color:".concat(colors/* default.brand-blue */.Z["brand-blue"], "}}}}}@media(max-width:").concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.text-part-component.jsx-5ddbce48fc0d5d15{&.big-text.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{font-size:8vw;line-height:10vw}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:24px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:5vw;line-height:3vw}}}}}@media(max-width:").concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.mobile-clean-look.jsx-5ddbce48fc0d5d15{.title-lines-wrapper.jsx-5ddbce48fc0d5d15{.title-line.jsx-5ddbce48fc0d5d15{display:block;font-size:8vw;line-height:9vw;font-weight:500;padding-left:10%;padding-right:10%;margin-bottom:0}}.subtitle-lines-wrapper.jsx-5ddbce48fc0d5d15{margin-bottom:24px;.subtitle-line.jsx-5ddbce48fc0d5d15{font-size:5vw;line-height:3vw}}.mobile-download-button-wrapper.jsx-5ddbce48fc0d5d15{.mobile-download-button{width:70%;min-width:220px;background-color:").concat(colors/* default.brand-blue */.Z["brand-blue"], "}}}}"));
_defaultExport.__hash = "5ddbce48fc0d5d15";
/* harmony default export */ var text_part_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.js





function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function text_part_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}














var TextPartComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TextPartComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TextPartComponent);
    function TextPartComponent() {
        (0,_class_call_check/* default */.Z)(this, TextPartComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TextPartComponent, [
        {
            key: "shouldRenderSubtitle",
            value: function shouldRenderSubtitle() {
                var mobileTitleLines = this.props.mobileTitleLines;
                return mobileTitleLines.length < 3;
            }
        },
        {
            key: "onDownloadLinkClicked",
            value: function onDownloadLinkClicked(e) {
                // Send cookies to the server.
                var visitorId = (0,cookies_service/* getCookie */.ej)(constants_cookies.BIG_BRAIN_VISITOR_ID);
                if (visitorId) {
                    var cookies = (0,cookies_service/* getAllCookies */.RV)();
                    sendCookies(visitorId, cookies);
                }
                BigBrain("track", bigbrain_event_types.MOBILE_DOWNLOAD_LINK_CLICK);
                window.open(getOnelinkWithTrackingParams());
            }
        },
        {
            key: "removeBoldTagForText",
            value: function removeBoldTagForText(text) {
                return text ? text.replace(/<b>/g, "").replace(/<\/b>/g, "") : "";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, mobileTitleLines = _props.mobileTitleLines, mobileSubtitleLines = _props.mobileSubtitleLines, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith, customStyle = _props.customStyle, color = _props.color, isMobileCleanLook = _props.isMobileCleanLook, isMobileOnly = _props.isMobileOnly;
                var _obj;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + (classnames_default()("text-part-component", (_obj = {}, (0,_define_property/* default */.Z)(_obj, customStyle, !!customStyle), (0,_define_property/* default */.Z)(_obj, "mobile-only", isMobileOnly), _obj)) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "title-lines-wrapper",
                            children: mobileTitleLines.map(function(line, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: colors/* default */.Z[color]
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: isMobileCleanLook ? _this.removeBoldTagForText(line) : line
                                    },
                                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + (classnames_default()("title-line", {
                                        first: index == 0
                                    }) || "")
                                }, index);
                            })
                        }),
                        this.shouldRenderSubtitle() && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "subtitle-lines-wrapper",
                            children: mobileSubtitleLines.map(function(line, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: colors/* default */.Z[color]
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: line
                                    },
                                    className: "jsx-".concat(text_part_component_scss.__hash) + " " + "subtitle-line"
                                }, index);
                            })
                        }),
                        signupForm.showDownloadButtonOnMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "mobile-download-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                                className: "mobile-download-button",
                                color: signupForm.buttonColor,
                                onClickCallback: this.onDownloadLinkClicked,
                                children: signupForm.downloadButtonTitle
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(text_part_component_scss.__hash) + " " + "signup-form-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                placeholder: signupForm.inputPlaceholder,
                                ctaText: signupForm.buttonText,
                                useCtaText: !!signupForm.buttonText,
                                buttonColor: signupForm.buttonColor
                            })
                        }),
                        collaborationWith.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(collaboration_with_component/* default */.Z, text_part_component_object_spread({}, collaborationWith)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: text_part_component_scss.__hash,
                            children: text_part_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return TextPartComponent;
}(react.PureComponent);

TextPartComponent.defaultProps = {
    mobileTitleLines: [],
    mobileSubtitleLines: []
};


/***/ }),

/***/ 42832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ParagraphWithLogosComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/paragraph/paragraph-component.js + 1 modules
var paragraph_component = __webpack_require__(94950);
// EXTERNAL MODULE: ./components/core/images-gallery/images-gallery-component.js
var images_gallery_component = __webpack_require__(66370);
// EXTERNAL MODULE: ./services/paragraph-service.js
var paragraph_service = __webpack_require__(54943);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/paragraph-with-logos/paragraph-with-logos-component.scss.js

var StyledParagraphWithLogosComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ekbuew80"
})(".paragraph-wrapper{margin-bottom:24px;}");

;// CONCATENATED MODULE: ./components/core/paragraph-with-logos/paragraph-with-logos-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var ParagraphWithLogosComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ParagraphWithLogosComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ParagraphWithLogosComponent);
    function ParagraphWithLogosComponent() {
        (0,_class_call_check/* default */.Z)(this, ParagraphWithLogosComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ParagraphWithLogosComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, paragraph = _props.paragraph, mobileImageWidthRatio = _props.mobileImageWidthRatio, assets = _props.assets, shadow = _props.shadow, textColor = _props.textColor;
                var screenRatios = {
                    mobile: mobileImageWidthRatio
                };
                var withContent = !(0,paragraph_service/* isContentEmpty */._)(paragraph);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledParagraphWithLogosComponent, {
                    className: "paragraph-with-logos-component",
                    children: [
                        withContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "paragraph-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, _object_spread_props(_object_spread({}, paragraph), {
                                textColor: textColor
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "image-gallery-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_gallery_component/* default */.Z, {
                                assets: assets,
                                shadow: shadow,
                                screenRatios: screenRatios
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return ParagraphWithLogosComponent;
}(react.PureComponent);



/***/ }),

/***/ 94950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ paragraph_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./components/core/colorful-title/colorful-title-component.js
var colorful_title_component = __webpack_require__(34215);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/paragraph/paragraph-component.scss.js



var StyledParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1y71bb50"
})("display:flex;flex-direction:column;justify-content:center;width:100%;flex:1 1 auto;&.center{align-items:center;text-align:center;.topic,.title,.body{max-width:650px;}}&.right{align-items:flex-end;}&.left{align-items:flex-start;}.topic{font-size:0.875rem;margin-bottom:16px;font-weight:500;}.title{.colorful-title,.colored{line-height:1.3;font-size:2.25rem;font-weight:700;}}.signup-form-with-decorations-wrapper{padding-top:16px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.title{.colored,.colorful-title{font-size:1.75rem;}}}");
var StyledBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1y71bb51"
})("	font-size:0.875rem;padding-top:16px;width:100%;.inner-body{display:block;line-height:27px;}");
var StyledBottomLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1y71bb52"
})("margin-top:24px;a{color:", colors/* default.black */.Z.black, ";&:hover{color:", colors/* default.brand-purple */.Z["brand-purple"], ";}}");

// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/lodash/replace.js
var replace = __webpack_require__(13880);
var replace_default = /*#__PURE__*/__webpack_require__.n(replace);
;// CONCATENATED MODULE: ./components/core/paragraph/paragraph-component.js







function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}











var ParagraphComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ParagraphComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ParagraphComponent);
    function ParagraphComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ParagraphComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderInnerBody", function() {
            var body = _this.props.body;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: body.map(function(paragraph, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inner-body",
                        dangerouslySetInnerHTML: {
                            __html: paragraph
                        }
                    }, index);
                })
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderBody", function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBody, {
                className: "body",
                children: [
                    " ",
                    _this.renderInnerBody(),
                    " "
                ]
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(ParagraphComponent, [
        {
            key: "renderBottomLink",
            value: function renderBottomLink() {
                var _bottomLink = this.props.bottomLink, text = _bottomLink.text, href = _bottomLink.href;
                var textColor = this.props.textColor;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomLink, {
                    className: "bottom-link-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: href,
                        style: {
                            color: colors/* default */.Z[textColor]
                        },
                        children: text
                    })
                });
            }
        },
        {
            key: "renderSignup",
            value: function renderSignup() {
                var _props = this.props, signupForm = _props.signupForm, isFirstSegment = _props.isFirstSegment;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "signup-form-with-decorations-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, _object_spread({
                        emailInputOpened: !!isFirstSegment
                    }, signupForm))
                });
            }
        },
        {
            key: "getTitle",
            value: function getTitle() {
                var _props = this.props, title = _props.title, hasFreeTier = _props.hasFreeTier;
                return hasFreeTier ? replace_default()(title, "Start your 14-day free trial", "") : title;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, image = _props.image, topic = _props.topic, title = _props.title, body = _props.body, textDirection = _props.textDirection, bottomLink = _props.bottomLink, titleFontSize = _props.titleFontSize, showSignup = _props.showSignup, isFirstSegment = _props.isFirstSegment;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledParagraphComponent, {
                    className: classnames_default()("paragraph-component", (0,_define_property/* default */.Z)({}, textDirection, textDirection)),
                    children: [
                        topic.text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "topic",
                            style: {
                                color: colors/* default */.Z[topic.color]
                            },
                            children: topic.text
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "title",
                            children: [
                                image && image.src && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, _object_spread({
                                    className: "title-image"
                                }, image)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(colorful_title_component/* default */.Z, {
                                    text: this.getTitle(),
                                    fontSize: titleFontSize,
                                    isH1Heading: isFirstSegment
                                })
                            ]
                        }),
                        body.length > 0 && this.renderBody(),
                        bottomLink.href && this.renderBottomLink(),
                        showSignup && this.renderSignup()
                    ]
                });
            }
        }
    ]);
    return ParagraphComponent;
}(react.PureComponent);
/* harmony default export */ var paragraph_component = ((0,segment_context/* withSegmentsData */.c)((0,generic_config_context/* withGenericConfig */.P)(ParagraphComponent)));
ParagraphComponent.defaultProps = {
    topic: {},
    title: "",
    body: [],
    bottomLink: {},
    showSignup: false
};


/***/ }),

/***/ 763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StarsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/stars/stars-component.scss.js

var StyledStarsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ek31l9l0"
})("display:flex;justify-content:center;.star-icon-wrapper{&:not(:last-child){margin-right:8px;}}");

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./components/core/stars/stars-component.js










var StarsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(StarsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(StarsComponent);
    function StarsComponent() {
        (0,_class_call_check/* default */.Z)(this, StarsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(StarsComponent, [
        {
            key: "renderStars",
            value: function renderStars() {
                var _props = this.props, numberOfSelectedStars = _props.numberOfSelectedStars, starsCount = _props.starsCount;
                var numberOfSelectedStarsAsInt = parseInt(numberOfSelectedStars);
                var starsCountAsInt = parseInt(starsCount);
                return times_default()(starsCountAsInt, function(index) {
                    var isSelected = numberOfSelectedStarsAsInt > index;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("star-icon-wrapper", {
                            selected: isSelected
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: "/static/img/star.png"
                        })
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var paddingTop = this.props.paddingTop;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStarsComponent, {
                    className: "stars-component",
                    style: {
                        paddingTop: paddingTop
                    },
                    children: this.renderStars()
                });
            }
        }
    ]);
    return StarsComponent;
}(react.PureComponent);

StarsComponent.defaultProps = {
    paddingTop: 0,
    numberOfSelectedStars: "5",
    starsCount: "5"
};


/***/ }),

/***/ 42307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompaniesLogosComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/paragraph-with-logos/paragraph-with-logos-component.js + 1 modules
var paragraph_with_logos_component = __webpack_require__(42832);
// EXTERNAL MODULE: ./components/segments/signup-with-animation/signup-with-animation-component.js + 1 modules
var signup_with_animation_component = __webpack_require__(32201);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/companies-logos/companies-logos-component.scss.js


var StyledCompaniesLogosComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1a47cua0"
})("position:relative;.images-gallery-row{display:flex;justify-content:space-evenly;padding:24px 40px;.image-gallery{.social-proof-gallery-picture{img{height:60px;}}}}.signup-wrapper{margin-top:48px;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.signup-wrapper{display:flex;justify-content:center;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.images-gallery-row{.image-gallery{padding:8px;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/logos/logos-const.js
var logos_const = __webpack_require__(83971);
;// CONCATENATED MODULE: ./components/segments/companies-logos/companies-logos-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var NUMBER_OF_COMPANIES = 7;
var CompaniesLogosComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CompaniesLogosComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CompaniesLogosComponent);
    function CompaniesLogosComponent() {
        (0,_class_call_check/* default */.Z)(this, CompaniesLogosComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CompaniesLogosComponent, [
        {
            key: "renderSignupWithAnimationIfNeeded",
            value: function renderSignupWithAnimationIfNeeded() {
                var _props = this.props, withAnimation = _props.withAnimation, _signupForm = _props.signupForm, signupForm = _signupForm === void 0 ? {} : _signupForm, showSignup = _props.showSignup;
                signupForm.showDecorations = false;
                return showSignup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "signup-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_with_animation_component/* default */.Z, {
                        withAnimation: withAnimation,
                        signupForm: signupForm
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var companiesAssets = (0,logos_const/* getCompaniesAssets */.yA)();
                var companiesAssetsSliced = companiesAssets.slice(0, NUMBER_OF_COMPANIES);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCompaniesLogosComponent, {
                    className: "companies-with-logos-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("paragraph-with-logos-wrapper"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_with_logos_component/* default */.Z, _object_spread_props(_object_spread({}, this.props), {
                                assets: companiesAssetsSliced
                            }))
                        }),
                        this.renderSignupWithAnimationIfNeeded()
                    ]
                });
            }
        }
    ]);
    return CompaniesLogosComponent;
}(react.PureComponent);

CompaniesLogosComponent.defaultProps = {
    paragraph: {
        title: "Join more than 330,000 users who manage teams better.",
        textDirection: "center"
    },
    signupForm: {},
    withAnimation: true,
    showSignup: true
};


/***/ }),

/***/ 74476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LottieAnimation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./components/core/lottie/lottie-component.js + 1 modules
var lottie_component = __webpack_require__(94703);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/lottie-animtaion/lottie-animation-component.scss.js


var StyledLottieAnimation = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "enmetgg0"
})("display:flex;justify-content:center;margin:auto;svg path{fill:", function(param) {
    var color = param.color;
    return color;
}, ";stroke:", function(param) {
    var color = param.color;
    return color;
}, ";}@media (min-width:", vp_sizes/* FOLD_TEST_MAX_WIDTH */.LM, "){&.above-the-fold{justify-content:flex-end;}}");

;// CONCATENATED MODULE: ./components/segments/lottie-animtaion/lottie-animation-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var VISIBLE_PORTION_OF_ANIMATION = 0.8;
var LottieAnimation = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LottieAnimation, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LottieAnimation);
    function LottieAnimation(props) {
        (0,_class_call_check/* default */.Z)(this, LottieAnimation);
        var _this;
        _this = _super.call(this, props);
        _this.onVisibilityChange = _this.onVisibilityChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            isVisible: false,
            reverseAnimation: false,
            animationPlayed: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(LottieAnimation, [
        {
            key: "onVisibilityChange",
            value: function onVisibilityChange(isVisible) {
                this.setState({
                    isVisible: isVisible,
                    reverseAnimation: !isVisible,
                    animationPlayed: isVisible || this.state.animationPlayed
                });
            }
        },
        {
            key: "shouldPlayAnimation",
            value: function shouldPlayAnimation() {
                return this.state.isVisible || this.state.animationPlayed;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, style = _props.style, animation = _props.animation, fireActionOnFrame = _props.fireActionOnFrame, textColor = _props.textColor, aboveTheFold = _props.aboveTheFold;
                var _state = this.state, reverseAnimation = _state.reverseAnimation, isVisible = _state.isVisible;
                var playOnlyWhenVisible = animation.playOnlyWhenVisible;
                var isVisibleOffset = parseInt(style.height) * VISIBLE_PORTION_OF_ANIMATION;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLottieAnimation, {
                    style: style,
                    color: style.color || textColor,
                    className: classnames_default()("lottie-animation-component", {
                        "above-the-fold": aboveTheFold
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                        offset: {
                            bottom: isVisibleOffset,
                            top: -10000
                        },
                        partialVisibility: true,
                        onChange: this.onVisibilityChange,
                        active: playOnlyWhenVisible,
                        scrollCheck: playOnlyWhenVisible,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_component/* default */.Z, _object_spread_props(_object_spread({}, animation), {
                            shouldPlay: this.shouldPlayAnimation(),
                            reverseAnimation: reverseAnimation,
                            fireActionOnFrame: fireActionOnFrame,
                            aboveTheFold: aboveTheFold
                        }))
                    })
                });
            }
        }
    ]);
    return LottieAnimation;
}(react.PureComponent);

LottieAnimation.defaultProps = {
    style: {
        height: "100px",
        animation: {}
    },
    animation: {
        loop: false,
        autoplay: false,
        playOnlyWhenVisible: true,
        jsonPath: "/static/lottie/arrow-swirl-down.json"
    }
};


/***/ }),

/***/ 56333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReviewsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/segments/reviews/reviews-component.scss.js

var StyledReviewsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1cmr5rk0"
})("display:flex;flex-direction:column;justify-content:center;.header-wrapper{display:flex;flex-direction:column;align-items:center;.title{margin-top:16px;font-size:1.375rem;font-weight:500;}}.reviews-wrapper{display:flex;flex-wrap:wrap;justify-content:center;.review-component-wrapper{margin:40px 32px 0;}}");

// EXTERNAL MODULE: ./components/core/stars/stars-component.js + 1 modules
var stars_component = __webpack_require__(763);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/review/review.scss.js


var StyledReview = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e7oig4l0"
})("height:100%;display:flex;flex-direction:column;align-items:center;word-break:break-word;text-align:center;.review-content{margin-top:16px;flex-grow:1;.line{font-size:1rem;line-height:30px;}}.reviewer-name{margin-top:24px;font-size:0.875rem;color:", colors/* default.jaco */.Z.jaco, ";font-style:italic;}.reviewed-on{font-size:0.8125rem;margin-top:16px;color:", colors/* default.jaco */.Z.jaco, ";}");

;// CONCATENATED MODULE: ./components/core/review/review.js







var Review = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Review, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Review);
    function Review(props) {
        (0,_class_call_check/* default */.Z)(this, Review);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(Review, [
        {
            key: "renderReviewContent",
            value: function renderReviewContent() {
                var reviewContent = this.props.reviewContent;
                return reviewContent.map(function(line, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line",
                        dangerouslySetInnerHTML: {
                            __html: line
                        }
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, reviewerName = _props.reviewerName, reviewedOn = _props.reviewedOn;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReview, {
                    className: "review-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "review-content",
                            children: this.renderReviewContent()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "reviewer-name",
                            children: reviewerName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "reviewed-on",
                            children: [
                                "Reviewed on ",
                                reviewedOn
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return Review;
}(react.PureComponent);

Review.defaultProps = {
    reviewContent: []
};

;// CONCATENATED MODULE: ./components/segments/reviews/reviews-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var ReviewsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ReviewsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ReviewsComponent);
    function ReviewsComponent() {
        (0,_class_call_check/* default */.Z)(this, ReviewsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ReviewsComponent, [
        {
            key: "renderReviews",
            value: function renderReviews() {
                var _props = this.props, columnWidth = _props.columnWidth, reviews = _props.reviews;
                return reviews.map(function(review, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "review-component-wrapper",
                        style: {
                            width: columnWidth
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Review, _object_spread({}, review))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReviewsComponent, {
                    className: "reviews-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "header-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "stars-component-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_component/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "title",
                                    children: "Why teams love monday.com"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "reviews-wrapper",
                            children: this.renderReviews()
                        })
                    ]
                });
            }
        }
    ]);
    return ReviewsComponent;
}(react.PureComponent);

ReviewsComponent.defaultProps = {
    columnWidth: "350px",
    reviews: []
};


/***/ }),

/***/ 83234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShortFooterComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_core_short_footer_short_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56914);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var ShortFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ShortFooterComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ShortFooterComponent);
    function ShortFooterComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ShortFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ShortFooterComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_short_footer_short_footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return ShortFooterComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 32201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignupWithAnimationComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/segments/lottie-animtaion/lottie-animation-component.js + 1 modules
var lottie_animation_component = __webpack_require__(74476);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/signup-with-animation/signup-with-animation-component.scss.js


var StyledSignupWithAnimationComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e86pj2m0"
})("position:relative;display:flex;justify-content:center;.inline-flex-wrapper{display:inline-flex;flex-direction:column;justify-content:center;position:relative;}&.left{justify-content:flex-start;}&.right{justify-content:flex-end;}.lottie-animation-wrapper{align-self:flex-end;width:150px;position:absolute;transform:translateX(95%) translateY(44px);right:0;top:0;}.button-wrapper{align-self:flex-end;}.button-wrapper.bounce-button{animation:bounce linear 0.8s;animation-iteration-count:1;transform-origin:50% 50%;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.lottie-animation-wrapper{left:0;right:0;margin:auto;transform:translateX(25%) translateY(150px) rotateZ(45deg);}}@keyframes bounce{0%{transform:translate(0px,0px);}15%{transform:translate(-10px,-10px);}30%{transform:translate(0px,0px);}45%{transform:translate(-7px,-7px);}60%{transform:translate(0px,0px);}75%{transform:translate(-3px,-3px);}100%{transform:translate(0px,0px);}}");

;// CONCATENATED MODULE: ./components/segments/signup-with-animation/signup-with-animation-component.js






function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}






var LOTTIE_ANIMATION_CONFIG = {
    animation: {
        jsonPath: "/static/lottie/arrow-swirl-left.json",
        loop: false,
        autoplay: false,
        playOnlyWhenVisible: true
    },
    style: {
        height: "100%"
    }
};
var FIRE_ACTION_FRAME = 27;
var SignupWithAnimationComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupWithAnimationComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupWithAnimationComponent);
    function SignupWithAnimationComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SignupWithAnimationComponent);
        var _this;
        _this = _super.call(this, props);
        _this.bounceSignup = _this.bounceSignup.bind((0,_assert_this_initialized/* default */.Z)(_this));
        LOTTIE_ANIMATION_CONFIG.fireActionOnFrame = {
            frame: FIRE_ACTION_FRAME,
            action: _this.bounceSignup
        };
        _this.state = {
            animated: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(SignupWithAnimationComponent, [
        {
            key: "bounceSignup",
            value: function bounceSignup() {
                var _this = this;
                if (this.state.animated) return;
                this.setState({
                    animated: true
                }, function() {
                    setTimeout(function() {
                        _this.setState({
                            animated: false
                        });
                    }, 2000);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, withAnimation = _props.withAnimation, signupForm = _props.signupForm, direction = _props.direction;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSignupWithAnimationComponent, {
                    className: classnames_default()("signup-with-animation-component", (0,_define_property/* default */.Z)({}, direction, direction)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inline-flex-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("button-wrapper", {
                                    "bounce-button": this.state.animated
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, _object_spread({}, signupForm))
                            }),
                            withAnimation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lottie-animation-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_animation_component/* default */.Z, _object_spread({}, LOTTIE_ANIMATION_CONFIG))
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return SignupWithAnimationComponent;
}(react.PureComponent);

SignupWithAnimationComponent.defaultProps = {
    withAnimation: true
};


/***/ }),

/***/ 18925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SocialProofComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/segments/social-proof/social-proof-component.scss.js

var StyledSocialProofComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11vt19s0"
})(".companies-logos-component-wrapper{margin-top:40px;}.reviews-component-wrapper{margin-top:40px;}.signup-with-decorations-component-wrapper{margin:71px 0px 64px;display:flex;justify-content:center;}");

// EXTERNAL MODULE: ./components/segments/companies-logos/companies-logos-component.js + 1 modules
var companies_logos_component = __webpack_require__(42307);
// EXTERNAL MODULE: ./components/segments/reviews/reviews-component.js + 3 modules
var reviews_component = __webpack_require__(56333);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
;// CONCATENATED MODULE: ./components/segments/social-proof/social-proof-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}






var SocialProofComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SocialProofComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SocialProofComponent);
    function SocialProofComponent() {
        (0,_class_call_check/* default */.Z)(this, SocialProofComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SocialProofComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, CompaniesLogos = _props.CompaniesLogos, Reviews = _props.Reviews, Signup = _props.Signup;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSocialProofComponent, {
                    className: "social-proof-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "companies-logos-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(companies_logos_component/* default */.Z, _object_spread({}, CompaniesLogos))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "reviews-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reviews_component/* default */.Z, _object_spread({}, Reviews))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-with-decorations-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, _object_spread({}, Signup))
                        })
                    ]
                });
            }
        }
    ]);
    return SocialProofComponent;
}(react.PureComponent);

SocialProofComponent.defaultProps = {
    CompaniesLogos: {
        paragraph: {},
        showSignup: false
    },
    Reviews: {
        columnWidth: "350px",
        reviews: [
            {
                reviewContent: [
                    '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
                ],
                reviewerName: "Dotan Egozi, monday.com"
            },
            {
                reviewContent: [
                    '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
                ],
                reviewerName: "Dotan Egozi, monday.com"
            }
        ]
    },
    Signup: {}
};


/***/ }),

/***/ 54943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ isContentEmpty; }
/* harmony export */ });
var isContentEmpty = function() {
    var content = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var title = content.title, body = content.body, topic = content.topic, bottomLink = content.bottomLink;
    if (title) return false;
    if (body && body.length > 0) return false;
    if (topic && topic.text) return false;
    if (bottomLink && bottomLink.href) return false;
    return true;
};


/***/ })

}]);